import 'babel-polyfill';
import 'whatwg-fetch';
import Vue from 'vue';
import ElementUI from 'element-ui';
import axios from 'axios';
import App from './App';
import router from './router';
import VueI18n from 'vue-i18n';
import Utils from '@/js/request_util';
import quality from '@/js/quality_util';
import commonstate from '@/js/constant';
import emijiUtils from '@/js/emoji';
import store from '@/store';
import './js/flexible.js';
import toastRegistry from '@/messages/messageIndex';
import filters from '@/js/filters';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/common_util.css';
import '@/assets/css/file_type.css';
import '@/assets/css/file_icon.css';
import '@/assets/css/drive_type.css';
import VueCookies from 'vue-cookies';
import clipboard from 'clipboard';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import gaPulgin from './plugins/analyst';
import menuController from './js/workspace/menu_controller';
//插件用多语言
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import deLocale from 'element-ui/lib/locale/lang/de'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import jpLocale from 'element-ui/lib/locale/lang/ja'
import frLocale from 'element-ui/lib/locale/lang/fr'
import ptLocale from 'element-ui/lib/locale/lang/pt'
import itLocale from 'element-ui/lib/locale/lang/it'
import esLocale from 'element-ui/lib/locale/lang/es'
import nlLocale from 'element-ui/lib/locale/lang/nl'

// import 'babel-polyfill';
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
Vue.use(VueCookies);
Vue.use(toastRegistry);
// Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.Utils = Utils;
Vue.prototype.$menu = menuController;
for (let key in filters) {
    Vue.filter(key, filters[key]);
}

//定义多语言
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'english', // 语言标识，用做切换和获取本地浏览器
    fallbackLocale: 'english', // 当前语言缺失 key 时回退到英文
    silentTranslationWarn: true, // 静默处理缺失翻译的警告
    messages: {
        'chinese': {...require('./assets/i18n/chinese'),...zhLocale},
        'english': {...require('./assets/i18n/english'),...enLocale},
        'deutsch': {...require('./assets/i18n/deutsch'),...deLocale},
        'france': {...require('./assets/i18n/france'),...frLocale},
        'portuguese': {...require('./assets/i18n/portuguese'),...ptLocale},
        'spanish': {...require('./assets/i18n/spanish'),...esLocale},
        'italian': {...require('./assets/i18n/italian'),...itLocale},
        'japanese': {...require('./assets/i18n/japanese'),...jpLocale},
        'traditionalChinese': {...require('./assets/i18n/traditional_Chinese'),...twLocale},
        'nederlands': {...require('./assets/i18n/nederlands'),...nlLocale},
    }
})

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

/*自定义全局指令*/
Vue.directive('clickoutside', Clickoutside);

/*自定义全局指令,右键关闭菜单以外区域*/
Vue.directive('rightclickoutside', {
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            e.preventDefault();
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e);
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.vueRightClickOutside = documentHandler;
        document.addEventListener("contextmenu", documentHandler);
    },
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("contextmenu", el.vueRightClickOutside);
        delete el.vueRightClickOutside;
    }
});

//自定义防止重复点击事件
Vue.directive('preventReClick', {
    inserted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 5000);
            }
        })
    }
});

/* 自定义全局禁止emoji */
Vue.directive('clearEmoji', emijiUtils);

/*自定义全局指令失焦事件*/
Vue.directive('mcBlur', {
    update(el, binding, vnode) {
        let mtinput = el.querySelector("input");
        if (mtinput != null) {
            mtinput.onblur = function(e) {
                binding.value(e);
            };
        }
    }
});

/*自定义全局指令聚焦事件*/
Vue.directive('mcFocus', {
    update(el, binding, vnode) {
        let mtinput = el.querySelector("input");
        if (mtinput != null) {
            mtinput.onfocus = function(e) {
                binding.value(e);
            };
        }
    }
});


axios.defaults.timeout = 180000;//如果请求超过3分钟没响应则超时
axios.defaults.retry = 3;                 //请求次数
axios.defaults.retryDelay = 10000;         //请求间隙
// http response 拦截器
// http response 拦截器
axios.interceptors.response.use(
    response => {
       //登录过期
        // if(response.data.errorCode == -1) {
        //     store.commit('logout', this);
        // }
        return response;
    },
    err => quality.retry(axios, err)
);

/* eslint-disable no-new */
quality.install(axios, () => commonstate);
window.vm = new Vue({
    el: '#allBox',
    i18n,
    router,
    store,
    components: { App },
    template: '<App/>',
})

//ga打点相关
Vue.prototype.$multcloudGA = async function (type) {
    //自动获取ud，所以限制必须已登录
    await Utils.doMCGARequest({gaType: type,}).then(res => {});
};

Vue.use(gaPulgin)



// WEBPACK FOOTER //
// ./src/main.js